import * as React from 'react';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';
import { useDrawingArea, useYScale } from '@mui/x-charts';
import { elevationFormatter, precipFormatter } from '../utils/format';
import WeatherChart from './WeatherChart';

function HorizontalRectangle({ axisId, yStart, yEnd }) {
  const { left, width } = useDrawingArea();
  const yScale = useYScale(axisId);
  const rectY = yScale(yEnd);
  const rectHeight = yScale(yStart) - yScale(yEnd);

  return (
    <rect
      x={left}
      y={rectY}
      width={width}
      height={rectHeight}
      fill="#d4d4d4"
      opacity={0.5}
    />
  );
}

export default function SnowLevelChart({
  forecast,
  location,
  xAxisPosition = 'bottom',
  showWind = true,
}) {
  const underlay = (
    <HorizontalRectangle
      axisId="left"
      yStart={location.minElevation}
      yEnd={location.maxElevation}
    />
  );

  const overlay = (
    <>
      <ChartsReferenceLine
        y={location.minElevation}
        label={location.minElevationLabel}
        lineStyle={{ strokeDasharray: '5 5' }}
        labelStyle={{ fontSize: 10 }}
        labelAlign="start"
      />
      <ChartsReferenceLine
        y={location.maxElevation}
        label={location.maxElevationLabel}
        lineStyle={{ strokeDasharray: '5 5' }}
        labelStyle={{ fontSize: 10 }}
        labelAlign="start"
      />
    </>
  );

  return (
    <WeatherChart
      forecast={forecast}
      left={{
        quantity: 'snowLevel',
        label: 'Snow Level',
        color: '#9c2d36',
        valueFormatter: (value) => `${elevationFormatter.format(value)} ft`,
        elevationLabel: false,
      }}
      right={{
        quantity: 'cumulativeSnowfallAmount',
        label: 'Snow',
        color: '#49b0c4',
        valueFormatter: (value) => `${precipFormatter.format(value)}"`,
      }}
      height={160}
      underlay={underlay}
      overlay={overlay}
      xAxisPosition={xAxisPosition}
      showWind={showWind}
    />
  );
}
